import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';
import type { TypographyProps } from '@material-ui/core/Typography';

export interface IParagraphProps {
    translation?: string;
    translationOptions?: object;
}

export type ParagraphProps = IParagraphProps & TypographyProps;

export const Paragraph: React.FC<ParagraphProps> = (props) => {
    const { t } = useTranslation();
    const {
        translation,
        translationOptions,
        children,
        variant = 'body1',
        gutterBottom = false,
        ...rest
    } = props;

    return (
        <Typography
            variant={variant}
            gutterBottom={gutterBottom}
            data-component="Paragraph"
            {...rest}
        >
            {translation && t(translation, translationOptions)}
            {!translation && children}
        </Typography>
    );
};

Paragraph.displayName = 'Paragraph';
